module.exports = __webpack_public_path__ + "img/clock.9c4e864b.svg";